import React from "react";
import { Tabs, Tab } from "@mui/material";

function ReferenceTabs({ selectedTab, handleTabChange, tabsData }) {
  return (
    <div className="border-bottom">
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="reference data tabs"
        sx={{
          "& .MuiTabs-indicator": { display: "none" },
          "& .MuiTab-root": {
            color: "rgba(0, 0, 0, 0.6)",
            backgroundColor: "#ccc",
            padding: "15px",
            borderRadius: "4px 4px 0 0",
            marginRight: "5px",
            "&.Mui-selected": {
              backgroundColor: "var(--theme-color)",
              color: "white",
              borderRadius: "4px 4px 0 0",
            },
          },
        }}
      >
        {tabsData.map((tab, idx) => (
          <Tab key={tab} label={tab} />
        ))}
      </Tabs>
    </div>
  );
}

export default ReferenceTabs;
